import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import _ from "lodash";
import DiagramUtils from "../utils/DiagramUtils";
import ContainerModel from './ContainerModel';
import Envelope from "../utils/Envelope";
import PropertyDescriptor from '../utils/PropertyDescriptor';

export default class CollectionModel extends ContainerModel {

    diagrams = new PropertyDescriptor([], '子集', "其他", undefined, undefined, {
        enabled: false
    });

    constructor() {
        super();
        this.backgroundColor.value = "transparent";
        this.borderWidth.value = 0;
        this.width.value = 500;
        this.height.value = 500;
        this.allowMask.value = false;
    }

    initialize(opts) {
        for (var p in opts) {

            if (opts[p] === undefined)
                continue;
            if (!(p in this))
                continue;

            if (p !== "diagrams") {
                this[p] = opts[p];
                continue;
            }

            const diagrams = DiagramUtils.diagrams;

            let models = [];
            opts[p].forEach(c => {

                const modelInfo = diagrams[c.type];
                if (!modelInfo)
                    return;

                let model = new modelInfo.model(c.model);
                model._sys.parent = this;
                model._sys.designer = this._sys.designer;
                models.push(model);
            });

            this.diagrams = models;
        }
    }

    addModel(model, refresh) {
        model._sys.parent = this;
        model._sys.designer = this._sys.designer;
        this.diagrams.push(model);
        if (refresh)
            this.diagrams = [...this.diagrams];

        this._sys.designer && this._sys.designer.raiseItemsChanged(model);
    }

    addModels(models, refresh) {
        models.forEach(m => this.addModel(m, false));
        if (refresh)
            this.diagrams = [...this.diagrams];

        this._sys.designer && this._sys.designer.raiseItemsChanged(models);
    }

    setModels(models) {
        this.diagrams = [...models];
        this._sys.designer && this._sys.designer.raiseItemsChanged(models);
    }

    insertModel(index, model, refresh) {

        model._sys.parent = this;
        model._sys.designer = this._sys.designer;
        this.diagrams.splice(index, 0, model)
        if (refresh)
            this.diagrams = [...this.diagrams];

        this._sys.designer && this._sys.designer.raiseItemsChanged(model);
    }

    deleteModel(model, refresh = true) {

        if (model._sys.allowDelete === false)
            return false;

        let i = this.diagrams.indexOf(model);
        if (i < 0)
            return;

        this.diagrams.splice(i, 1);

        if (refresh)
            this.diagrams = [...this.diagrams];

        this._sys.designer && this._sys.designer.raiseItemsChanged(model);
    }

    deleteModels(models, refresh) {
        models.forEach(c => this.deleteModel(c, false));
        if (refresh)
            this.diagrams = [...this.diagrams];

        this._sys.designer && this._sys.designer.raiseItemsChanged(models);
    }

    setRandomId() {
        super.setRandomId();
        this.diagrams.forEach(c => {
            c.setRandomId();
        });
    }

    setRandomFlag(notify) {
        super.setRandomFlag(notify);

        if (this.hidden)
            return;

        this.diagrams.forEach(c => {
            c.setRandomFlag(notify);
        });
    }

    expandModels() {

        let models = [];
        this.diagrams.forEach(c => {
            models = [...models, ...c.expandModels()];
        })

        models.push(this);
        return models;
    }

    findById(id) {
        if (this.id === id)
            return this;

        for (const d of this.diagrams) {
            const found = d.findById(id);
            if (found)
                return found;
        }

        return null;
    }

    toJsonObject() {

        let o = {
            type: this.getType(),
            model: {},
        }

        for (const key in this) {
            if (key === "diagrams")
                continue;

            const element = this[key];
            let v = null;
            if (element instanceof ObservablePropertyDescriptorObject)
                v = element.toJsonObject();
            else if (element instanceof Array) {
                v = element.map(c => c && c.toJsonObject && c.toJsonObject() || c);
            }
            else
                v = element;

            o.model[key] = v;
        }

        let obj = o;

        obj.model.diagrams = [];
        this.diagrams.forEach(c => {
            if (c._sys.temp)
                return;
            obj.model.diagrams.push(c.toJsonObject());
        });

        return obj;
    }

    toStyle() {
        let style = {
            ...super.toStyle(),
            borderRadius: 0,
            ...super.getExtendStyle(),
        }

        // style.pointerEvents = this._sys.designer && this._sys.designer.mode === "view" ? "auto" : "none";
        style.pointerEvents = this._sys.designer && this._sys.designer.mode !== "view" && this.isEdit || this.overflowX || this.overflowY ? "auto" : "none";
        // style.pointerEvents = "none";

        return style;
    }

    toCollectionStyle() {
        let style = {
            overflowY: this.overflowY ? "auto" : "unset",
            overflowX: this.overflowX ? "auto" : "unset",
            padding: this.padding.toString(),
            // borderRadius: 0,
            ...super.getExtendStyle(),
        }

        style.pointerEvents = this._sys.designer && this._sys.designer.mode === "view" ? "auto" : "none";

        return style;
    }

    isFindable(model, index) {
        return true;
    }

    findIntersects(x, y, tolerance = 0) {

        let intersects = [];
        if (this._sys.temp)
            return intersects;

        let diagrams = _.orderBy(this.diagrams, c => c.zIndex);

        for (let i = diagrams.length - 1; i >= 0; i--) {
            const model = diagrams[i];
            if (!this.isFindable(model, i))
                continue;

            const founds = model.findIntersects(x, y, tolerance);

            if (founds instanceof Array && founds.length > 0)
                intersects = [...intersects, ...founds];
            else if (!(founds instanceof Array) && founds)
                intersects.push(founds);
        }

        const location = this.getViewLocation();
        const size = this.getViewSize();

        if (new Envelope({ left: location.x, top: location.y, width: size.width, height: size.height }).intersectsByXY(x, y, tolerance)) {
            intersects.push(this);
        }

        return intersects;
    }

    findWithInRectangle(x, y, width, height, tolerance = 0) {

        let intersects = [];
        if (this._sys.temp)
            return intersects;

        for (let i = 0; i < this.diagrams.length; i++) {
            const model = this.diagrams[i];
            if (!this.isFindable(model, i))
                continue;

            const founds = model.findWithInRectangle(x, y, width, height, tolerance);

            if (founds instanceof Array && founds.length > 0)
                intersects = [...intersects, ...founds];
            else if (!(founds instanceof Array) && founds)
                intersects.push(founds);
        }

        const location = this.getViewLocation();
        const size = this.getViewSize();

        if (new Envelope({ left: x, top: y, width: width, height: height }).containsByEnvelop(new Envelope({ left: location.x, top: location.y, width: size.width, height: size.height }), tolerance)) {
            intersects.push(this);
        }

        return intersects;
    }
}
